export enum AssetClassUserEvents {
    ChangeNetFlowsTimeframe = "Asset Classes - Change Net Flows Timeframe",
}
